import styles from './FileItem.module.css'
import { 
    DocumentRegular,
    Dismiss16Regular
} from "@fluentui/react-icons";

export const FileItem = ({file, onRemove} : { file: File, onRemove: (name: string) => void}) => {
    return (
        <div className={styles.fileItemPill}>
            <DocumentRegular className={styles.fileIcon} />
            <span className={styles.fileName} title={file.name}>
                {file.name}
            </span>
            <button 
                className={styles.removeFileBtn} 
                onClick={(e) => { e.stopPropagation(); onRemove(file.name); }}
            >
                <Dismiss16Regular />
            </button>
        </div>
    );
};

